import { FIELD_COLOR_CLASS } from '../../../document/components/PromptEditor.tsx';

// Shared with the field configuration's instructions box (fineTuning/RuleFieldsBox), so the Template tab looks and
// behaves like it: the same framed field, tags and focus ring.
export const FIELD_FRAME_CLASS =
    'flex flex-col rounded border border-solid border-line-default bg-surface-weak outline-2 outline-transparent transition-colors duration-200 hover:border-line-hover focus-within:border-line-focus focus-within:outline-line-weak';
export const TAG_CLASS = 'inline-flex items-center gap-1 rounded py-0.5 pl-1.5 pr-1 text-xs font-medium';
export const FOCUS_CLASS = 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-line-brand-strong';

// A plain value reads like the field config's input data (purple), a loop like its output fields (brand); a
// built-in value (workist.*) is neutral.
export const VARIABLE_COLOR_CLASS = {
    variable: FIELD_COLOR_CLASS.input,
    loop: FIELD_COLOR_CLASS.output,
    builtin: 'bg-surface-strong text-content-strong',
} as const;
